﻿import React, { useContext, useEffect } from 'react';
//import { setBookingflowStep } from '../../../../../Resources/Scripts/_Shared/history';

import { BookingFlowContext } from '../BookingFlowContext'
import { Heading } from '../partials/Heading'
import OnlineBookingLtp from './OnlineBookingLtp'
import OnlineBookingStp from './OnlineBookingStp'
import { NearbyFacilities } from '../partials/NearbyFacilities'

export const ACTIONS = {
  OVERRIDE: 'override-state',
  DATE: 'update-date',
  PRODUCT: 'update-product',
  PAYMENT: 'update-payment',
  SPOT_COUNT: 'update-spotcount',
  SPOT_COUNT_INCREMENT: 'update-spotcount-increment',
  SPOT_SELECTION: 'update-spotselection',
  SPOT_SELECTION_INCREMENT: 'update-spotselection-inrcement',
  PENDING: 'pending',
  PENDING_TRUE: 'pending-true',
  PENDING_FALSE: 'pending-false',
  ACCESS_DEVICES: 'access-devices',
  ACCESS_DEVICES_OPTIONAL: 'access-devices-optional',
}

const OnlineBooking = () => {
  const {bookingFlowContext} = useContext(BookingFlowContext);

  const formLang = bookingFlowContext.localization.onlineBooking;

  useEffect(() => {
    history.replaceState({ activeStep: 0 }, document.title);
  }, [])

  return (
    <div className="bookingflowpage__app bookingflowpage__app--onlinebooking">
      <Heading />
      <div className="single-step single-step--booking">
        <h2>{formLang.heading}</h2>

        {bookingFlowContext.episerver.productType === 1 && <OnlineBookingLtp />}
        {bookingFlowContext.episerver.productType === 2 && <OnlineBookingStp />}
      </div>
      {bookingFlowContext.facility.nearbyFacilities?.length > 0 && <NearbyFacilities />}
    </div>
  )
}

export default OnlineBooking;
